import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Tracks assay report download state for global UI feedback.
 *
 * Kept separate from ExportWorkbookStatusService rather than sharing one flag so
 * that a workbook export and a report download running together cannot hide each
 * other's banner when the first of them finishes.
 */
@Injectable({ providedIn: 'root' })
export class ReportDownloadStatusService {
  private readonly generatingSubject = new BehaviorSubject<boolean>(false);
  readonly generating$ = this.generatingSubject.asObservable();

  start(): void {
    this.generatingSubject.next(true);
  }

  stop(): void {
    this.generatingSubject.next(false);
  }
}
